(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-beneficio-foto"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bc-scroll-buy]');
    if (!a) return;
    var form = document.querySelector('form[id^="ProductForm-"]');
    var target = form && (form.querySelector('.add-to-cart') || form);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-cifras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animate(el) {
      var v = parseFloat(el.getAttribute('data-value')) || 0;
      var fg = el.querySelector('.bc-ring__fg');
      var num = el.querySelector('.bc-ring__num');
      if (!fg || !num) return;
      fg.style.transition = 'none';
      fg.setAttribute('stroke-dasharray', '0 100');
      requestAnimationFrame(function () {
        fg.style.transition = '';
        fg.setAttribute('stroke-dasharray', v + ' 100');
      });
      var t0 = null;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / 1200, 1);
        num.textContent = Math.round(v * p) + '%';
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function init() {
      var rings = document.querySelectorAll('.bc-ring:not([data-bc-ready])');
      if (!rings.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
      rings.forEach(function (r) { r.setAttribute('data-bc-ready', '1'); io.observe(r); });
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-ficha-estilos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fit() {
      var m = document.querySelector('.bc-ficha-flag') && document.querySelector('.product .item-media');
      if (!m) return;
      var top = parseInt(getComputedStyle(m).top, 10);
      if (!isNaN(top) && top >= 0) document.documentElement.style.setProperty('--bc-top', top + 'px');
    }
    function init() { fit(); setTimeout(fit, 400); setTimeout(fit, 1500); }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('resize', fit);
  })();

  (function () {
    function init() {
      document.querySelectorAll('.quantity .select.number').forEach(function (box) {
        if (box.querySelector('.bc-q')) return;
        var input = box.querySelector('input[type=number]');
        if (!input) return;
        function mk(cls, label, delta) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'bc-q ' + cls; b.textContent = label; b.setAttribute('aria-label', delta > 0 ? 'Más' : 'Menos');
          b.addEventListener('click', function () {
            var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 9999;
            var n = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + delta));
            input.value = n; input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          box.appendChild(b);
        }
        mk('bc-q--minus', '−', -1); mk('bc-q--plus', '+', 1);
      });
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-recomendados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load() {
      document.querySelectorAll('.bc-rec[data-bc-rec-url]').forEach(function (sec) {
        var url = sec.getAttribute('data-bc-rec-url');
        sec.removeAttribute('data-bc-rec-url');
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var track = doc.querySelector('[data-bc-track]');
          var mine = sec.querySelector('[data-bc-track]');
          if (track && track.children.length && mine) { mine.innerHTML = track.innerHTML; }
          else { sec.style.display = 'none'; }
        }).catch(function () { sec.style.display = 'none'; });
      });
    }
    if (document.readyState !== 'loading') load(); else document.addEventListener('DOMContentLoaded', load);
  })();

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-bc-rec]');
    if (arrow) {
      var track = arrow.parentElement.querySelector('[data-bc-track]');
      if (track) track.scrollBy({ left: parseInt(arrow.getAttribute('data-bc-rec'), 10) * track.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var q = e.target.closest('[data-bc-qty]');
    if (q) {
      var input = q.parentElement.querySelector('input');
      var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-bc-qty'), 10));
      input.value = n;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-sticky-comprar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var bar = document.querySelector('[data-bc-stk]');
      var form = document.querySelector('form[id^="ProductForm-"]');
      var target = form && (form.querySelector('.add-to-cart') || form);
      if (!bar || !target) return;
      var ticking = false;
      function update() {
        ticking = false;
        var passed = target.getBoundingClientRect().bottom <= 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
